<template>
  <div class="forum-detail">
    <!-- 公共头部 -->
    <!-- <vHeader></vHeader> -->
    <!-- 视频部分div -->
    <div class="video-box">
      <div class="contain">
        <el-row class="row-one">
          <el-row>
            <el-col :span="18">
              <video :src="$store.state.imgUrl+videoFile" controls controlslist="nodownload" :autoplay="false" :poster="$store.state.imgUrl+stanceImg"></video>
            </el-col>
            <el-col :span="6" style="padding-left:10px">
              <div class="video-title clearfix">
                {{ name }}
                <div class="collection-count">共{{ countJiShu }}集</div>
              </div>
              <div class="video-line"></div>
              <div class="jishuDuan">
                <el-row class="collection">
                  <el-button size="mini" icon="el-icon-arrow-left"></el-button>
                  <div class="title-video-w">
                    <el-button
                    size="mini"
                    class="title-video"
                    v-for="(item, index) in jiData"
                    :class="item.checked ? 'red-color' : ''"
                    :key="index"
                    @click="selectJishuDuan(item)"
                    >{{ item.top }}</el-button
                  >
                  </div>
                  
                  <el-button size="mini" icon="el-icon-arrow-right"></el-button>
                </el-row>
              </div>
              <el-row class="collection-list jishuDuan" v-if="false">
                <el-button
                  size="mini"
                  v-for="(item, index) in selectAllJi"
                  :class="item.checked ? 'red-color' : ''"
                  :key="index"
                  @click="selectJiF(item)"
                  >{{ item.value }}</el-button>
              </el-row>
              <el-row>
                <el-col :span="24" class="jianshu">简述：</el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="jianshu-word" >
                  <div v-html="jianshu"></div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-col :span="18" class="video-share-collect-viewCount">
            <span @click="shareF()" class="shou">
              <img
                src="../assets/img/40.png"
                alt
                class="img-after-word"
              />分享：
              <span class="four-share">
                <share
                  :config="config1"
                  style="display:inline-block"
                  v-if="isShare"
                ></share>
              </span>
            </span>
            <span v-if="!isCollection" @click="collectF(0)" class="shou">
              <img src="../assets/img/42.png" alt class="img-after-word" />收藏
            </span>
            <span v-else @click="collectF(1)" class="shou">
              <img
                src="../assets/img/43.png"
                alt
                class="img-after-word"
              />已收藏
            </span>
            <span style="margin-left:20px">
              <img src="../assets/img/41.png" alt class="img-after-word" />
              观看量:{{ llCount }}
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <span class="collection-name">{{ name }}：{{ currentJiW }}</span>
            <span class="lecturer">讲师：{{ author }}</span>
            <!-- </el-col>
                        <el-col :span="4">-->
            <span class="comment-button shou" @click="goDiv()">
              <span>全部评论</span>
              <!-- <a href="#jumpComment">全部评论</a> -->
            </span>
          </el-col>
          <el-col :span="6">
            <div class="collection-button" @click="collectFAll()">
              <i class="el-icon-star-off"></i>我的收藏
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 下半部分div -->
    <div class="content-width">
      <el-row :gutter="20">
        <el-col :span="18">
          <el-row>
            <el-col :span="18">
              <div class="prescription">关联药膳配方</div>
            </el-col>
            <el-col :span="6">
              <div class="buy-car shou" @click="addCar()">购药</div>
            </el-col>
          </el-row>
          <el-table
            :data="prescriptionSlaves"
            style="width: 100%;margin:20px 0px;"
            class="yaoTable"
          >
            <el-table-column :label="prescriptionName" align="center">
              <el-table-column
                prop="medicineName"
                label="中草药名称"
              ></el-table-column>
              <el-table-column prop="dosage" label="剂量"></el-table-column>
              <el-table-column prop="unit" label="单位"></el-table-column>
              <el-table-column prop="year" label="年代"></el-table-column>
            </el-table-column>
          </el-table>
          <el-row>
            <el-col :span="24">
              <div class="prescription">详细描述</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="detailed-description" v-html="xxms"></div>
            </el-col>
          </el-row>

          <el-row id="jumpComment" style="margin-top:50px">
            <el-col :span="24">
              <el-input
                placeholder="我也来评论一下..."
                v-model="commentText"
                class="input-with-select fabu-reverse comment-button-padding-j"
              >
                <template slot="append">
                  <span class="release-btn shou" @click="fabuComment()"
                    >发布</span
                  >
                </template>
              </el-input>
            </el-col>
          </el-row>

          <el-row class="jcomment" id="navs">
            <el-col :span="20">
              <div class="prescription">评论</div>
            </el-col>
            <el-col :span="4">
              <div class="comment-count">（{{ commentTotal }}条）</div>
            </el-col>
          </el-row>
          <!--评论  -->
          <el-row
            class="jcomment-list"
            v-for="(item, index) in commentList"
            :key="index"
          >
            <!-- 评论内容 -->
            <el-row>
              <el-col :span="2">
                <img :src="$store.state.imgUrl+ item.headImg" alt class="head-img" />
              </el-col>
              <el-col :span="20" class="common-list">
                <div>
                  {{ item.username }}
                  <span class="commentime">{{ item.createDate }}</span>
                </div>
                <div class="jcomment-content">{{ item.commentText }}</div>
              </el-col>
              <!-- <el-col :span="2">
                                <img
                                    src="../assets/img/34.png"
                                    alt
                                    class="resver"
                                    @click="item.commentRever =true"
                                />
                            </el-col>-->
            </el-row>
            <!-- 回复评论内容 -->
            <!-- <el-row class="jcomment-list reverse-jcomment-list">
                                <el-col :span="2">
                                    <img src="../assets/img/39.png" alt class="head-img" />
                                </el-col>
                                <el-col :span="20" class="common-list">
                                    <div>
                                        浩天哲
                                        <span class="commentime">2019-07-11 09:20</span>
                                    </div>
                                    <div class="jcomment-content">
                                        回复
                                        <span class="reverse-name">医师</span>:讲的很好，从中学到了很多小窍门，以后有时间还会接着观看，中医还是很强大啊！！！
                                    </div>
                                </el-col>
                                <el-col :span="2">
                                    <img src="../assets/img/34.png" alt class="resver" />
                                </el-col>
                                <el-row>
                                    <el-col :span="24">
                                        <el-input
                                            placeholder="我也来评论一下..."
                                            v-model="comment"
                                            class="input-with-select fabu-reverse reverse-comment comment-button-padding-j"
                                        >
                                            <template slot="append">
                                                <span class="release-btn">回复</span>
                                            </template>
                                        </el-input>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col class="inner-comment-view-more">
                                        查看更多回复
                                        <i class="el-icon-d-arrow-right"></i>
                                    </el-col>
                                </el-row>
                        </el-row>-->

            <!-- <el-row v-if="item.commentRever">
                            <el-col :span="24">
                                <el-input
                                    placeholder="我也来评论一下..."
                                    v-model="comment"
                                    class="input-with-select fabu-reverse reverse-comment comment-button-padding-j"
                                >
                                    <template slot="append">
                                        <span
                                            class="release-btn"
                                            @click="item.commentRever = false"
                                        >回复</span>
                                    </template>
                                </el-input>
                            </el-col>
                        </el-row>-->
          </el-row>
          <!-- 查看更多 -->
          <el-row class="center-more">
            <el-col :span="24">
              <div
                class="view-more"
                @click="moreDate()"
                v-if="
                  commentList.length > 0 && commentTotal != commentList.length
                "
              >
                查看更多
              </div>
              <div
                class="view-more"
                v-if="commentList.length <= 0"
                style="border:none"
              >
                暂无评论
              </div>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="6">
          <el-row>
            <el-col :span="24" class="adv-wrap">
              <div
                class="common-img-outer setPositon listdetail-adver-outer-img"
                v-for="(item, index) in jingtangAdverList"
                :key="index"
              >
                <a :href="item.urlLink">
                  <img :src="$store.state.imgUrl+item.urlImage" alt style="width:100%" />
                  <span class="adver-words-tip" v-if="item.urlImage">{{
                    adverWordsTip
                  }}</span>
                </a>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "ForumDetail",
  data() {
    return {
      routeId: "", //讲堂id
      // id: "", //每一集的id
      forumId: "", //讲堂id
      comment: "", //评论内容
      countJiShu: "", //总集数
      prescription: "",
      name: "",
      jianshu: "",
      llCount: "",
      stanceImg: "",
      videoFile: "",
      author: "",
      prescriptionName: "",
      xxms: "",
      collectionId: "",
      prescriptionSlaves: [],
      commentText: "", //评论内容
      currentJiW: "", //当前集数汉字
      currentJishuId: "", //当前集数id
      couple: {}, //集数对象
      jiData: [], //集数段,每个集数段的集数,选中状态
      selectAllJi: [] //选中的所有集展示
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    goDiv() {
      document.getElementById("navs").scrollIntoView({ behavior: "smooth" });
    },
    //加入购物车
    addCar() {
      let that = this;
      if (!that.isLoginF()) return false;

      //立即购买
      this.$router.push({
        path: "/ReceivingAddress2",
        query: { id: that.prescription }
      });
    },
    //收藏与取消收藏
    collectF(a) {
      let that = this;
      if (!that.currentJishuId) {
        that.currentJishuId = that.currentJishuId;
      }
      if (a == 0) {
        // 此时要收藏
        that.collect(that.currentJishuId, 3);
      } else {
        that.unCollect(that.currentJishuId, 3);
      }
    },
    // 选择集数
    selectJiF(item) {
      let that = this;
      that.currentJishuId = item.id;
      that.currentJiW = item.value;
      that.getDetail(that.currentJishuId);
      for (let c of that.selectAllJi) {
        c.checked = false;
      }
      item.checked = true;
    },
    // 选择集数段
    selectJishuDuan(item) {
      let that = this;
      // 集数段的选中状态
      for (let c of that.jiData) {
        c.checked = false;
      }
      item.checked = true;
      that.selectAllJi = [];
      for (let key in item.bottom) {
        if (that.currentJishuId == key) {
          that.selectAllJi.push({
            id: key,
            value: item.bottom[key],
            checked: true
          });
        } else {
          that.selectAllJi.push({
            id: key,
            value: item.bottom[key],
            checked: false
          });
        }
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    //获取讲堂集数
    async getTotal(id) {
      let that = this;
      let url = "/medicineForum/getMedicineForumByCount";
      let parmas = {
        id: id
      };
      await that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            that.countJiShu = arr.count;
            that.couple = arr.couple;
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    //获得每一集的详情,id集数id
    getDetail(currentJishuId) {
      let that = this;
      if (sessionStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      }
      let url = "/medicineForum/getMedicineForumCountByDetail";
      let parmas = {
        id: currentJishuId,
        userId: that.userInfo.id
      };
      that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            that.commentList = [];
            that.commentPageInfo.pageNum = 1;
            that.getAllComment(currentJishuId); //获取全部评论
            that.prescription = arr.prescription;
            that.jianshu = arr.jianshu;
            that.name = arr.name;
            that.llCount = arr.llCount;
            that.stanceImg = arr.stanceImg;
            that.videoFile = arr.videoFile;
            that.author = arr.author;
            that.prescriptionName = arr.prescriptionName;
            that.xxms = arr.xxms;
            that.collectionId = arr.collectionId;
            if (!!that.collectionId) {
              // 收藏了
              that.isCollection = true;
            } else {
              //没收藏
              that.isCollection = false;
            }
            that.prescriptionSlaves = arr.prescriptionSlaves.map(
              (item, index) => {
                return {
                  dosage: item.dosage,
                  unit: item.unit,
                  medicineName: item.medicineName,
                  year: arr.year
                };
              }
            );
            // if (!!arr.authorizeStopTime) {
            //     if (
            //         that.changeChuo(
            //             that.getTime(arr.authorizeStopTime)
            //         ) < Date.now()
            //     ) {
            //         console.log("过期了");
            //     }
            // }
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    //发布评论
    fabuComment() {
      let that = this;
      if (!that.commentText) {
        that.$message.error("请您输入评论内容");
        return false;
      }
      that
        .addComment(that.currentJishuId, that.name, that.commentText)
        .then(res => {
          that.commentPageInfo.pageNum = 1;
          that.commentList = [];
          that.getAllComment(that.currentJishuId);
          that.commentText = "";
        });
    },
    //查看更多数据
    moreDate() {
      let that = this;
      that.commentPageInfo.pageNum++;
      that.getAllComment(that.currentJishuId);
    },
    removeTags(str) {
      return str.replace(/<[^>]+>/g, '');
    },
    //我的收藏
    collectFAll() {
      if (!this.isLoginF()) return false;
      let pathStr = '/myCollection'
      if(this.userInfo && this.userInfo.userType == 2){
        pathStr = '/myCollectionT' 
      } 
      this.$router.push({
        path: pathStr,
        query: { i: 1 }
      });
    }
  },
  created() {
    let that = this;
    that.getPositionAdver(2, 3);
    if (!!that.$route.query.id) {
      that.routeId = that.$route.query.id;

      that.getDetail(that.routeId); //每一集的详情
      //集数的分割
      that.getTotal(that.routeId).then(res => {
        for (let i in that.couple) {
          let perJi = that.couple[i];
          //讲堂分组集数
          that.jiData.push({
            top: i,
            bottom: perJi,
            checked: false
          });
        }
        for (let i = 0; i < that.jiData.length; i++) {
          for (let j in that.jiData[i].bottom) {
            //每一集的显示
            if (j == that.routeId) {
              that.currentJishuId = j;
              that.currentJiW = that.jiData[i].bottom[j];
              that.jiData[i].checked = true;
              that.selectAllJi.push({
                id: j,
                value: that.jiData[i].bottom[j],
                checked: true
              });
            } else {
              that.selectAllJi.push({
                id: j,
                value: that.jiData[i].bottom[j],
                checked: false
              });
            }
          }
        }
      });

      //获取讲堂集数
      // that.getTotal(that.routeId).then(res => {
      //     for (let i in that.couple) {
      //         let perJi = that.couple[i];
      //         //讲堂分组集数
      //         that.jiData.push({
      //             top: i,
      //             bottom: perJi,
      //             checked: false
      //         });
      //     }
      //     //默认为第一集
      //     if (that.jiData.length > 0) {
      //         that.jiData[0].checked = true;
      //         let k = 0;
      //         for (var key in that.jiData[0].bottom) {
      //                 if (k == 0) {
      //                     k = k + 1;
      //                     that.currentJishuId = key; //当前选中集数id
      //                     that.getDetail(that.currentJishuId);
      //                     for (let i in that.jiData[0].bottom) {
      //                         that.selectAllJi.push({
      //                             id: i,
      //                             value: that.jiData[0].bottom[i],
      //                             checked: false
      //                         });
      //                     }
      //                     if (that.selectAllJi.length > 0) {
      //                         that.selectAllJi[0].checked = true;
      //                         that.currentJiW = that.selectAllJi[0].value;
      //                     }
      //                 }
      //         }
      //     }
      // });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
video::-webkit-media-controls-timeline {
display: none;
}
.display-none {
  display: none;
}
.forum-detail {
  margin-bottom: 100px;
}
.adv-list {
  padding: 10px;
}
.input-with-select {
  background-color: #f9f9f9;
  border: 1px solid #dcdfe6;
  /* margin: 60px auto 30px; */
}
.release-btn {
  width: 50px;
  display: block;
  height: 24px;
  line-height: 24px;
  background-color: #f64420;
  border-radius: 16px;
  color: white;
  text-align: center;
}

.detailed-description {
  font-size: 16px;
  text-align: justify;
  line-height: 36px;
  letter-spacing: 1.6px;
  color: #666666;
}
/deep/.detailed-description p{
  text-indent: 40px;
}
thead .cell {
  text-align: center;
}
.buy-car {
  width: 120px;
  height: 32px;
  background-color: #f64420;
  border-radius: 16px;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 1.6px;
  color: #ffffff;
  text-align: center;
  float: right;
}

.collection-button {
  width: 210px;
  height: 52px;
  background-color: #f87461;
  font-size: 16px;
  line-height: 52px;
  letter-spacing: 1.6px;
  color: #ffffff;
  text-align: center;
  margin: 0px auto;
  cursor: pointer;
}
.comment-button {
  width: 120px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 16px;

  font-size: 16px;
  line-height: 36px;
  margin-top: 14px;
  letter-spacing: 1.6px;
  color: #ffffff;
  float: right;
  text-align: center;
  margin-right: 20px;
}
.comment-button a {
  color: #b4b3b3;
}
.comment-button span {
  letter-spacing: 1.6px;
  color: #ffffff;
  opacity: 0.5;
  display: block;
  text-align: center;
}
.lecturer {
  font-size: 16px;
  line-height: 56px;
  letter-spacing: 1.6px;
  color: #ffffff;
}
.collection-name {
  font-size: 24px;
  line-height: 50px;
  letter-spacing: 2.4px;
  color: #f95809;
}
/deep/.jianshu-word {
  width: 236px;
  height: 294px;
  font-size: 14px;
  /* line-height: 22px; */
  letter-spacing: 1.4px;
  color: #808080;
  text-align: justify;
  padding: 0px 15px;
  /* height: 160px; */
  overflow: auto;
}
/deep/.jianshu-word p{
  text-indent: 20px;
}
/* 滚动条轨道样式 */
::-webkit-scrollbar {
  width: 3px; /* 设置滚动条宽度 */
}
 
/* 滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #888; /* 设置滑块背景颜色 */
  border-radius: 4px; /* 设置滑块圆角 */
}
 
/* 滚动条轨道hover状态样式 */
::-webkit-scrollbar-track:hover {
  background-color: #f1f1f1; /* 设置轨道hover状态时的背景颜色 */
}
 
/* 滚动条滑块hover状态样式 */
::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* 设置滑块hover状态时的背景颜色 */
}
.jianshu {
  font-size: 16px;
  line-height: 50px;
  letter-spacing: 1.8px;
  color: #ffffff;
  text-align: left;
}
.collection {
  display: flex;
  justify-content: space-between;
  text-align: left;
  border-bottom: 1px dashed #4E4C4C;
  padding:8px 0;
}


.collection-list .el-button {
  background-color: transparent;
  border: none;
  color: white;
  /* margin-left: 16px;
    line-height: 30px; */
}
.jishuDuan .collection .red-color,
.jishuDuan .red-color {
  color: #f64420;
}
.video-box .row-one {
  background-color: #2b2b2b;
  margin-bottom: 10px;
}
.video-box .row-one video {
  width: 100%;
  height: 431.48px;
}
.video-box {
  width: 100%;
  padding: 20px 0px 10px;
  background-color: #333333;
}
.video-title {
  font-size: 18px;
  line-height: 50px;
  letter-spacing: 1.8px;
  color: #ffffff;
  text-align: left;
  box-sizing:border-box;
  padding: 0 5px;
}
.collection-count {
  float: right;
  font-size: 14px;
  line-height: 50px;
  letter-spacing: 1.4px;
  color: #ffffff;
  opacity: 0.3;
}
.video-line {
  width: 100%;
  height: 1px;
  background-color: #ffffff;
  opacity: 0.1;
}
/* .el-button+.el-button{
  margin-left: 5px;
} */
.collection .el-button {
  background: transparent;
  border: none;
  color: #e3e3e3;
  margin-left: 0px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.collection .el-button--mini,
.el-button--mini.is-round {
  padding: 0px 5px;
}
.video-share-collect-viewCount {
  font-size: 14px;
  color: #b4b3b3;
  text-align: right;
  padding-right: 20px;
  height: 30px;
  line-height: 30px;
}
.video-share-collect-viewCount .four-share img {
  margin-right: 20px;
}
.video-share-collect-viewCount img {
  vertical-align: middle;
}
.video-share-collect-viewCount .img-after-word {
  margin-right: 5px;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 7px 14px;
}
.head-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.prescription {
  font-size: 22px;
  line-height: 36px;
  letter-spacing: 2.2px;
  color: #333333;
}
@keyframes scroll {
  0% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.title-video-w{
  /* display: inline-block; */
  width: 170px;
  overflow: hidden;
}
.title-video  {
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  padding-left: 100%; 
  animation: scroll 10s linear infinite;
}
/* 控制面板样式 */
.row-one video::-webkit-media-controls-panel {
  background: linear-gradient(to bottom, transparent 88%, rgba(0,0,0,.3) 93%, rgba(0,0,0,.5)100%) !important;
}
</style>




// WEBPACK FOOTER //
// src/components/ForumDetailv.vue